import wasm from "../../build/psp.sync.wasm";
export default wasm;
